import { ANGULAR_GENETICS_PATH_MATCHES } from 'ui/Genetics/Activation/paths';
import { ANGULAR_PROVIDERS_EXACT_PATH_MATCHES } from 'ui/ProviderPlatform/Providers/paths';

export const ANGULAR_EXACT_PATH_MATCHES = [
  ...ANGULAR_PROVIDERS_EXACT_PATH_MATCHES,
  ...ANGULAR_GENETICS_PATH_MATCHES,
];
